import yup from 'yup'

const passwordRex = new RegExp('^(?=.*\\d)(?=.*[!@#$%^&*\\.\\,\\:])(?=.*[a-z])(?=.*[A-Z]).{8,32}$');

const schema = yup
  .object()
  .shape({
    name: yup.string().min(3, 'Minimum 3 characters')
                      .max(64, 'Too long (max 64 characters)')
                      .required('Name is required'),
    id_code: yup.string().min(6, "Code must be six digits!") 
                         .max(6, "Code must be six digits!")
                         .required('A 6-digit code is required')
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/Employee/schema.js